import web from "../image/web.webp"
import app from "../image/app.jpeg"
import android from "../image/android.jpeg"
import digital from "../image/digital.webp"
import marketing from "../image/marketing.jpg"
import software from "../image/softwere.webp"

const Sdata = [
    {
        imgsrc: web,
        title: "web development"
    },
    {
        imgsrc: app,
        title: "app development"
    },
    {
        imgsrc: android,
        title: "android development"
    },
    {
        imgsrc: digital,
        title: "digital development"
    },
    {
        imgsrc: marketing,
        title: "marketing development"
    },
    {
        imgsrc: software,
        title: "software development"
    }
    
];

export {Sdata} ;